import { render } from "./FantrackingView.vue?vue&type=template&id=dcaf2fe0&scoped=true&ts=true"
import script from "./FantrackingView.vue?vue&type=script&lang=ts"
export * from "./FantrackingView.vue?vue&type=script&lang=ts"

import "./FantrackingView.vue?vue&type=style&index=0&id=dcaf2fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcaf2fe0"]])

export default __exports__